/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespStorytellingText_storyTellingTab = {
    readonly tabTitle: string;
    readonly contentHeader: string | null;
    readonly contentCreatorAttribution: {
        readonly creatorName: string;
        readonly creatorBrowseUrl: {
            readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
        };
    } | null;
    readonly contentBodyText: string;
    readonly tabType: string;
    readonly " $refType": "PdpRespStorytellingText_storyTellingTab";
};
export type PdpRespStorytellingText_storyTellingTab$data = PdpRespStorytellingText_storyTellingTab;
export type PdpRespStorytellingText_storyTellingTab$key = {
    readonly " $data"?: PdpRespStorytellingText_storyTellingTab$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespStorytellingText_storyTellingTab">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespStorytellingText_storyTellingTab",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tabTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentHeader",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoryTellingModuleCreator",
      "kind": "LinkedField",
      "name": "contentCreatorAttribution",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "creatorName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "creatorBrowseUrl",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentBodyText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tabType",
      "storageKey": null
    }
  ],
  "type": "StoryTellingTab",
  "abstractKey": null
};
(node as any).hash = '50a63a8d7548625c473af72bb210664f';
export default node;
